module.exports = "/shifts/components/filters/dropdownFilter-cfb6c3.html";